import { SvgIcon, SvgIconProps } from "@mui/material";

// Tight 14x14 glyph from Figma - rendered inside the minimized tag pill (CIRCLE_PILL_SX)
export const IconLowBetaMinimized = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 14 14">
        <g clipPath="url(#clip0_low_beta_minimized)">
            <path
                d="M8.74564 5.0639C9.45066 4.8172 9.95654 4.14607 9.95654 3.35723C9.95654 2.85314 9.75026 2.3972 9.41796 2.06966C8.85205 1.51147 8.0751 1.16669 7.21731 1.16669C5.48627 1.16669 4.08337 2.57018 4.08337 4.30063V12.8334H5.9125V9.6691C6.29592 10.2528 6.95575 10.6386 7.70654 10.6386C9.29967 10.6386 10.5908 9.3475 10.5908 7.75438C10.5908 6.52803 9.82516 5.4812 8.74624 5.0639H8.74564ZM7.1115 9.28092C6.55747 9.28092 6.08726 8.92663 5.9119 8.43324V3.85657C5.9119 3.19554 6.4475 2.65994 7.10853 2.65994C7.76956 2.65994 8.30516 3.19554 8.30516 3.85657C8.30516 4.36839 7.89023 4.78332 7.37841 4.78332H6.78931V5.99005H7.11209C8.02101 5.99005 8.75753 6.72657 8.75753 7.63549C8.75753 8.5444 8.02101 9.28092 7.11209 9.28092H7.1115Z"
                fill="#179C5F"
            />
        </g>
        <defs>
            <clipPath id="clip0_low_beta_minimized">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </SvgIcon>
);
